import { prop } from "../../decorators/property";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { AppSettings } from "../../app-settings";
import { AuthorizationModel } from "../../authentication/models/authorization-model";

export class FullTextRevisionsModel extends Backbone.AssociatedModel {

    @prop() public Reference: string;
    @prop() public Id: string;

    public ErrorMessage = `<div class="legislation-gov-error"><h5>Sorry</h5><p>We could not connect to www.legislation.gov.uk to find the latest revision of this document</p></div> `;
    constructor(options?) {
        super(options);
    }

    public getLink(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
                $.ajax({
                    url: `${AppSettings.ApiUrlPrefix}fulltextsources`,
                    data: { "": [this.Reference] },
                    dataType: "json",
                    type: "POST",
                    beforeSend: AuthorizationModel.attachAuthorizationHeader
                }).then((data) => {
                    if (data && data.length) {
                        const govData: any = _.where(data[0].Links, {SiteId: 14})[0];
                        if (govData && govData.Url) {
                            resolve(govData.Url);
                        } else {
                            reject(this.ErrorMessage);
                        }
                    }
                });
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/full-text-revisions.ts